import { render, staticRenderFns } from "./LearningPage.vue?vue&type=template&id=23f3edec&scoped=true"
import script from "./LearningPage.vue?vue&type=script&lang=js"
export * from "./LearningPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f3edec",
  null
  
)

export default component.exports